import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoManufacturing = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>Manufacturing</title>
    <path
      d="M27.064 26.347V5.24c0-.685-.556-1.241-1.241-1.241h-3.725c-.685 0-1.241.556-1.241 1.241v8.69M4.718 26.347V13.932c0-.686.556-1.242 1.241-1.242h13.657c.685 0 1.24.556 1.24 1.242v12.415"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      clipRule="evenodd"
      d="M15.124 17.689h-4.517 4.517ZM27.064 8.966h-6.207 6.207ZM15.124 21.79h-4.517 4.517Z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M3 26.914h25.782" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
export default SvgIcoManufacturing;
